import {common_utils} from "../common/common_utils";
import {game_2002_2004} from "./game_2002_2004";

function game_2000()
{

}
game_2000.getWinInfo = function(obj)
{
  let winInfo = "";
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }

  let AnteBet = common_utils.getValue(obj,"AnteBet");
  let FlopBet = common_utils.getValue(obj,"FlopBet");
  let RiverBet = common_utils.getValue(obj,"RiverBet");
  let TurnBet = common_utils.getValue(obj,"TurnBet");
  let BonusBet = common_utils.getValue(obj,"BonusBet");
  let BonusWin = common_utils.getValue(obj,"BonusWin");
  let Win = common_utils.getValue(obj,"Win");
  if(Win>0||BonusWin>0)
  {
    winInfo += "("+ common_utils.getValueFixed(Win) +"+"+ common_utils.getValueFixed(BonusWin) + ")" + " - ("
      + common_utils.getValueFixed(AnteBet) + "+" +common_utils.getValueFixed(FlopBet)+ "+" +common_utils.getValueFixed(RiverBet)
      + "+" +common_utils.getValueFixed(TurnBet)+ "+" +common_utils.getValueFixed(BonusBet)+ ")";
    winInfo += " = "
  }
  if(Win>0)
  {
    winInfo +="(";
    winInfo += common_utils.getValueFixed(AnteBet)+"+"+common_utils.getValueFixed(FlopBet)+"+"+common_utils.getValueFixed(RiverBet);
    winInfo +=")";
  }
  else
  {
    winInfo += " - ("+common_utils.getValueFixed(AnteBet)+"+"+common_utils.getValueFixed(FlopBet)+"+"+common_utils.getValueFixed(RiverBet)+"+"+common_utils.getValueFixed(TurnBet)+")";
  }

  winInfo += " - "+common_utils.getValueFixed(BonusBet);
  if(Win>0||BonusWin>0)
  {
    winInfo += " + "+common_utils.getValueFixed(BonusWin);
  }

  let winValue = ((Win + BonusWin)-AnteBet-FlopBet-RiverBet-TurnBet-BonusBet);
  winInfo += " = "+ common_utils.getValueFixed(winValue);


  return winInfo;
}

export {
  game_2000
};



// WEBPACK FOOTER //
// ./src/components/joker/game_2000.js